import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import { Notification } from '@xsolla/ui-core';

import { useConfig } from '../../../contexts/config';
import { agreementPath } from '../../../routes/routesHelper';
import { Notice } from '../icons';
import { LinkStylesUnderline } from '../Link';
import { Wrapper } from './styles';

const AgreementNotification = (): JSX.Element => {
  const { merchantId } = useConfig();

  return (
    <Wrapper data-test-id="agreement-notification">
      <Notification palette="brand" icon={Notice}>
        <LinkStylesUnderline>
          <FormattedMessage
            id="agreement.not-signed.notification"
            values={{
              a: (chunk: string) => <Link to={agreementPath(merchantId)}>{chunk}</Link>
            }}
          />
        </LinkStylesUnderline>
      </Notification>
    </Wrapper>
  );
};

export default AgreementNotification;
